const messages = {
	signUpSuccess: "Successfully registered! You've been signed in as well.",
	signUpFailure:"Registration failed. Email may be taken, or passwords don't match.",
	signInSuccess: 'Welcome!',
	signInFailure:'Failed to sign in. Check your email and password and try again.',
	signOutSuccess: 'Come back soon!',
	changePasswordSuccess: 'Password changed successfully!',
	changePasswordFailure:'Failed to change passwords. Check your old password and try again.',
	generalError: 'Something went wrong. Please try again.',
	createWishSuccess: 'Wish Item created successfully!',
	deleteGameSuccess: 'Game deleted successfully!',
	updateGameSuccess: 'Game updated successfully!',
}

module.exports = messages